<template>
<div>
    <div class="devices" v-if="maintainerdata.length != 0">
      <div class="card-body">
        <div style="text-align:center;margin-bottom:1%">
          <v-avatar size="200" tile style="box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6);">
            <img
              class="elevation-5"
              :alt="$route.params.name"
              :src="maintainerdata.image"
            >
          </v-avatar>
        </div>
        <h5 class="card-title" style="text-align:center">{{ this.$route.params.name }}</h5>
          <v-list-item style="text-align:center">
            <v-list-item-content>
              <v-list-item-subtitle>
                <a class="buttona" v-if="maintainerdata.telegram" :href="maintainerdata.telegram" target="__blank"><i class="bi bi-telegram"></i></a>
                <a class="buttona" v-if="maintainerdata.github" :href="maintainerdata.github" target="__blank"><i class="bi bi-github"></i></a>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        <v-divider></v-divider>
        <div v-if="maintainerdata" class="latestbuilds">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle style="white-space:inherit"><strong>Devices : </strong>  
                <i v-if="maintainerdata.rmx1971 == 'Y'"><a href="/RMX1971">Realme 5 Pro</a></i>
                <i v-if="maintainerdata.rmx1971 == 'Y' && maintainerdata.r5x == 'Y'">,&nbsp;</i>
                <i v-if="maintainerdata.r5x == 'Y'"><a href="/r5x">Realme 5 Series</a></i>
                <i v-if="maintainerdata.even == 'Y' && maintainerdata.r5x == 'Y' || maintainerdata.rmx1971 == 'Y' && maintainerdata.even == 'Y'">,&nbsp;</i>
                <i v-if="maintainerdata.even == 'Y'"><a href="/EVEN">Realme C25 Series</a></i>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="maintainerdata.rmx1971 == 'Y'"><strong>Realme 5 Pro : </strong><p></p>
                <i v-if="maintainerbuilddata['roms']">
                  <i v-if="maintainerbuilddata['roms']['rmx1971']">Roms : 
                    <i v-for="i in maintainerbuilddata['roms']['rmx1971'].length" :key="i">
                      <a :href="'/RMX1971/'+$route.params.name+'/'+maintainerbuilddata['roms']['rmx1971'][i-1]">{{ maintainerbuilddata['roms']['rmx1971'][i-1] }}</a>
                      <i v-if="i < maintainerbuilddata['roms']['rmx1971'].length">, </i>
                    </i>
                  </i>
                </i><p></p>
                <i v-if="maintainerbuilddata['kernels']">
                  <i v-if="maintainerbuilddata['kernels']['rmx1971']">Kernels : 
                    <i v-for="i in maintainerbuilddata['kernels']['rmx1971'].length" :key="i">
                      <a :href="'/RMX1971/'+$route.params.name+'/'+maintainerbuilddata['kernels']['rmx1971'][i-1]">{{ maintainerbuilddata['kernels']['rmx1971'][i-1] }}</a>
                      <i v-if="i < maintainerbuilddata['kernels']['rmx1971'].length">, </i>
                    </i>
                  </i>
                </i> <p></p>
                <i v-if="maintainerbuilddata['recoveries']">
                  <i v-if="maintainerbuilddata['recoveries']['rmx1971']">Recoveries : 
                    <i v-for="i in maintainerbuilddata['recoveries']['rmx1971'].length" :key="i">
                      <a :href="'/RMX1971/'+$route.params.name+'/'+maintainerbuilddata['recoveries']['rmx1971'][i-1]">{{ maintainerbuilddata['recoveries']['rmx1971'][i-1] }}</a>
                      <i v-if="i < maintainerbuilddata['recoveries']['rmx1971'].length">, </i>
                    </i>
                  </i>
                </i>
              </v-list-item-subtitle>

              <v-list-item-subtitle v-if="maintainerdata.r5x == 'Y'"><strong>Realme 5 Series : </strong><p></p>
                <i v-if="maintainerbuilddata['roms']"><i v-if="maintainerbuilddata['roms']['r5x']">Roms : 
                <i v-for="i in maintainerbuilddata['roms']['r5x'].length" :key="i">
                  <a :href="'/r5x/'+$route.params.name+'/'+maintainerbuilddata['roms']['r5x'][i-1]">{{ maintainerbuilddata['roms']['r5x'][i-1] }}</a>
                  <i v-if="i < maintainerbuilddata['roms']['r5x'].length">, </i>
                </i>
                </i></i><p></p>
                <i v-if="maintainerbuilddata['kernels']"><i v-if="maintainerbuilddata['kernels']['r5x']">Kernels : 
                <i v-for="i in maintainerbuilddata['kernels']['r5x'].length" :key="i">
                  <a :href="'/r5x/'+$route.params.name+'/'+maintainerbuilddata['kernels']['r5x'][i-1]">{{ maintainerbuilddata['kernels']['r5x'][i-1] }}</a>
                  <i v-if="i < maintainerbuilddata['kernels']['r5x'].length">, </i>
                </i>
                </i> </i><p></p>
                <i v-if="maintainerbuilddata['recoveries']"><i v-if="maintainerbuilddata['recoveries']['r5x']">Recoveries : 
                <i v-for="i in maintainerbuilddata['recoveries']['r5x'].length" :key="i">
                  <a :href="'/r5x/'+$route.params.name+'/'+maintainerbuilddata['recoveries']['r5x'][i-1]">{{ maintainerbuilddata['recoveries']['r5x'][i-1] }}</a>
                  <i v-if="i < maintainerbuilddata['recoveries']['r5x'].length">, </i>
                </i></i>
                </i>
              </v-list-item-subtitle>

              <v-list-item-subtitle v-if="maintainerdata.even == 'Y'"><strong>Realme C25 Series : </strong><p></p>
                <i v-if="maintainerbuilddata['roms']"><i v-if="maintainerbuilddata['roms']['even']">Roms : 
                <i v-for="i in maintainerbuilddata['roms']['even'].length" :key="i">
                  <a :href="'/EVEN/'+$route.params.name+'/'+maintainerbuilddata['roms']['even'][i-1]">{{ maintainerbuilddata['roms']['even'][i-1] }}</a>
                  <i v-if="i < maintainerbuilddata['roms']['even'].length">, </i>
                </i>
                </i></i><p></p>
                <i v-if="maintainerbuilddata['kernels']"><i v-if="maintainerbuilddata['kernels']['even']">Kernels : 
                <i v-for="i in maintainerbuilddata['kernels']['even'].length" :key="i">
                  <a :href="'/EVEN/'+$route.params.name+'/'+maintainerbuilddata['kernels']['even'][i-1]">{{ maintainerbuilddata['kernels']['even'][i-1] }}</a>
                  <i v-if="i < maintainerbuilddata['kernels']['even'].length">, </i>
                </i>
                </i> </i><p></p>
                <i v-if="maintainerbuilddata['recoveries']"><i v-if="maintainerbuilddata['recoveries']['even']">Recoveries : 
                <i v-for="i in maintainerbuilddata['recoveries']['even'].length" :key="i">
                  <a :href="'/EVEN/'+$route.params.name+'/'+maintainerbuilddata['recoveries']['even'][i-1]">{{ maintainerbuilddata['recoveries']['even'][i-1] }}</a>
                  <i v-if="i < maintainerbuilddata['recoveries']['even'].length">, </i>
                </i>
                </i></i>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="maintainerdata.content"><strong>About maintainer : </strong>  
                <i v-html="maintainerdata.content"></i>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
    </div>
    <div class="devices1" v-if="loadingdata && maintainerdata.length == 0">
        <v-progress-circular
        :rotate="180"
        :size="100"
        :width="15"
        :value="value"
        color="blue"
        >
        {{ value }}
        </v-progress-circular>
    </div>
    <div class="devices1" v-if="nodata">
        <img src="../assets/404.png" alt="404(Not Found)">
        <h1>404</h1>
        <p>No Data Found</p>
    </div>
</div>
</template>
<script>
import axios from 'axios';

  export default {
    name: 'MaintainerData',
    components: {
    },
    data: () => ({
        maintainerdata: [],
        maintainerbuilddata: [],
        loadingdata: false,
        nodata: false,
        interval: {},
        value: 10
    }),
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    },
    created () {
        this.getmaintainersbuilddata();
        this.getmaintainersdata();
    },

    methods: {
        getmaintainersdata() {
            let maintainer = `?maintainer=${this.$route.params.name}`
            let config = {
                method : 'get',
                url : `https://kharame-devices.herokuapp.com/getMaintainersData${maintainer}`,
            };
            this.loadingdata=true;
            axios(config)
            .then((response) => {
                if (response && response.data.message && response.data.status === 'S'){
                    this.data = response.data.message;
                    this.maintainerdata = this.data[0];
                }
                if (this.maintainerdata) {
                    this.loadingdata = false;
                } else {
                    setTimeout(() => { this.loadingdata = false; }, 2000);
                    setTimeout(() => { this.nodata = true; }, 2000);
                }
            })
        },
        getmaintainersbuilddata() {
            let maintainer = `?maintainer=${this.$route.params.name}`
            let config = {
                method : 'get',
                url : `https://kharame-devices.herokuapp.com/getMaintainersBuildData${maintainer}`,
            };
            axios(config)
            .then((response) => {
                if (response && response.data.message && response.data.status === 'S'){
                    this.maintainerbuilddata = response.data.message;
                }
            })
        },
    },
  }
</script>
<style scoped>
.devices {
  margin-top:8%;
  margin-bottom: 4%;
  margin-left: auto;
  margin-right: auto;
  width:50%;
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6);
}
.devices1 {
  text-align: center;
  margin-top:8%;
  margin-bottom: 4%;
  margin-left: auto;
  margin-right: auto;
  width:85%;
}

.v-list-item__content .v-list-item__subtitle{
  color :whitesmoke !important;
  font-size: 14px;
  padding:1%;
}
.buttona{
  color :whitesmoke !important;
  font-size: 26px;
  padding:2%;
}
>>>.ql-align-center {
    text-align : center;
}
>>>.ql-align-right {
    text-align : right;
}
.v-list-item__title, .v-list-item__subtitle{
  white-space: inherit;
}
@media (max-width: 1000px) {
  .devices {
    width: 75%;
    margin-top: 10%;
    margin-bottom: 5%;
  }
  .devices1 {
    margin-top: 10%;
    margin-bottom: 5%;
  }
}
@media (max-width: 550px) {
  .devices {
    width: 85%;
    display: block;
    margin-top: 18%;
     margin-bottom: 12%;
  }
  .devices1 {
    margin-top: 18%;
    margin-bottom: 12%;
  }
}
</style>